<!-- FABRIC INFORMATION -->
<div class="row">
  <div class="col-sm-12">
    <app-card [cardOptionBtnValue]="'global.actions.edit'|translate"
              [cardOptionBtnIcon]="'feather'"
              [cardOptionBtn]="true"
              [cardRouterLink]="(fabric.fabricCollection?'/back-office/fabric-collection/'+fabric.fabricCollection['id']+'/fabric/'+fabric.id:'')"
              [title]="'doctrine.fabric.information'|translate">
      <div class="row">
        <div class="col-sm-12 col-xl-3">
          <p class="text-muted m-b-10">{{'doctrine.fabric.name'|translate}}</p>
          <label class="m-b-15">{{fabric.name}}</label>
        </div>
        <div class="col-sm-12 col-xl-3">
          <p class="text-muted m-b-10">{{'doctrine.fabric.fabric_collection'|translate}}</p>
         <!-- <label class="m-b-15">{{(fabricCollection) ? fabricCollection['name'] : ''}}</label>-->
          <label class="m-b-15">{{(fabric.fabricCollection) ? fabric.fabricCollection['name']: ''}}</label>
        </div>
        <div class="col-sm-12 col-xl-3">
          <p class="text-muted m-b-10">{{'doctrine.fabric.dealer_price'|translate}}</p>
          <label class="m-b-15">
            {{fabric.dealerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
          </label>
        </div>
        <div class="col-sm-12 col-xl-3">
          <p class="text-muted m-b-10">{{'doctrine.fabric.customer_price'|translate}}</p>
          <label class="m-b-15">
            {{fabric.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
          </label>
        </div>
        <div class="col-sm-12 col-xl-3">
          <p class="text-muted m-b-10">{{'global.status'|translate}}</p>
          <label class="m-b-15">{{fabric.status}}</label>
        </div>
      </div>

    </app-card>
  </div>
</div>

<!-- FABRIC COLORS -->
<div class="row">
  <div class="col-sm-12">
    <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate "
              [cardOptionBtnIcon]="'feather icon-plus'"
              [cardOptionBtn]="!archive"
              [title]="('doctrine.fabric_color.title'|translate) + ' (' + fabricColors.length + ')'"
              (outputButton)="openModalForAddColor()">
      <div class="table-responsive">

        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{'doctrine.fabric_color.image'|translate}}</th>
            <th>{{'doctrine.fabric_color.color'|translate}}</th>
            <th>{{'doctrine.fabric_color.supplier'|translate}}</th>
            <th>{{'global.status'|translate}}</th>
            <th *ngIf="!archive">{{'global.position'|translate}}</th>
            <th>{{'global.actions'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let color of fabricColors">
            <td>
              <img width="50" height="50" *ngIf="color.image" [src]="baseURL+'/'+color.image.fullPath" alt=""/>
              <img width="50" height="50" *ngIf="!color.image"
                   [src]="baseURL+'/uploads/private/FabricColor_image/fabric_default_image.jpg'" alt=""/>
            </td>
            <td>{{color.name|titlecase}}</td>
            <td>{{color.supplier|titlecase}}</td>
            <td>{{(color.status ? 'global.'+getFabric().ACTIVE : 'global.'+getFabric().INACTIVE)|translate}}</td>
            <td *ngIf="!archive">
              <input type="number"
                     min="-1"
                     (blur)="setParentPosition(color.id,color.parentPosition)"
                     name="position"
                     [(ngModel)]="color.parentPosition"
                     class="form-control"
                     style="max-width:60px"></td>
            <td>
              <span class="action-button">
                <a class="ripple light ms-2" (click)="openModalForEditColor(color)"
                          *ngIf="!archive">
                  <i class="fa fa-pencil fa-lg"></i>
                </a>
              </span>
              <span class="action-button">
                <a class="ripple light ms-2" (click)="openModalForDeleteColor(color)"
                     *ngIf="!archive">
                  <i class="fa fa-remove fa-lg"></i>
                </a>
              </span>
              <span class="action-button">
                <a class="ripple light ms-2"
                     (click)="setDetailForReadd(color)"
                     *ngIf="archive">
                  <i class="feather icon-plus fa-lg"></i>
                </a>
              </span>
            <td>
          </tr>
          </tbody>
        </table>
      </div>
      <button *ngIf="!archive" class="btn btn-primary ripple light pull-right my-3" (click)="getDeleteColors()" type="button"
        >{{'global.view_archive'|translate}}</button>
      <button *ngIf="archive" class="btn btn-primary ripple light pull-right my-3" (click)="getColors()" type="button"
      >{{'doctrine.fabric.view_colors'|translate}}</button>
    </app-card>

  </div>
</div>

<!-- ADD COLOR TO FABRIC -->
<app-modal-basic #addColorToFabricModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
    {{(isEdit ? 'global.soft_edit_title' : 'global.soft_add_title') | translate:{entity: 'Color'} }}
    </h4>
    <button type="button" class="close basic-close" (click)="closeFabricColorModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addColorForm="ngForm">
      <h4 class="sub-title">{{'doctrine.fabric_color.information'| translate}}</h4>
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label for="colorName">{{"doctrine.fabric_color.name" | translate}} *</label>
          <input required name="colorName"
                 id="colorName"
                 #colorName="ngModel"
                 class="form-control"
                 [(ngModel)]="fabricColor.name">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="colorName.invalid && colorName.dirty && colorName.errors?.required">{{'errors.required'|translate}}</div>
        </div>
        <div class="form-group col-md-6">
          <label for="uploaderFile">{{"doctrine.fabric_color.image" | translate}}</label>
          <label class="custom-file">
            <input type="file" ng2FileSelect [uploader]="uploader" class="custom-file-input"
                   #uploadEl id="uploaderFile" accept=".jpg,.png,.jpeg,.gif">
            <button (click)="changeImage($event)" class="custom-file-control-upload">{{(uploader.queue.length > 0 ? "global.change_file" : "global.choose_file")|translate}}</button>
            <span style="overflow: hidden"
              class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
            <span class="custom-file-control"
                  *ngIf="this.fabricColorImg">{{this.fabricColorImg}}</span>
            <div class="row">
              <!-- Loading Style -->
              <div class="preloader3 loader-block mx-auto" *ngIf="isUploading">
                <div class="circ1 loader-success"></div>
                <div class="circ2 loader-success"></div>
                <div class="circ3 loader-success"></div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.fabric_color.other' | translate}}</h4>
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label for="status">{{'doctrine.fabric_color.status' | translate}} *</label>
          <ng-select
            [(ngModel)]="fabricColor.status"
            id="status"
            name="status" [clearable]="false">
            <ng-option  [value]="true">{{'global.active' | translate}}</ng-option>
            <ng-option [value]="false">{{'global.inactive' | translate}}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-md-6">
          <label for="colorName">{{"doctrine.fabric_color.supplier" | translate}} *</label>
          <input required name="supplier"
                 id="supplier"
                 #supplier="ngModel"
                 class="form-control"
                 [(ngModel)]="fabricColor.supplier">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="supplier.invalid && supplier.dirty && supplier.errors?.required">{{'errors.required'|translate}}</div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="closeFabricColorModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="addColor()" [disabled]="!addColorForm.valid || isUploading">
      {{(isEdit ? 'global.save_changes' : 'global.add') | translate}}

    </button>
  </div>
</app-modal-basic>
<app-modal-basic #deleteModal >
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'color'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <b [innerHTML]="color"></b> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDeleteColor()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'color'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="color"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="readdModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>
